<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.compliancedocument"
				:id="id"
				:models="models"
				:infos="infos"
				topClass=""
			></show>

			<!-- Workflow di approvazione -->
			<v-card v-if="document" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Workflow di approvazione</p>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<div class="d-flex align-center flex-wrap">
						<span class="mr-3">Stato attuale:</span>
						<v-chip :color="statusMeta(document.status).color" dark label class="mr-4">
							<v-icon left small>{{ statusMeta(document.status).icon }}</v-icon>
							{{ statusMeta(document.status).text }}
						</v-chip>
						<span class="mr-2 grey--text">Versione {{ document.version }}</span>
						<v-spacer></v-spacer>
						<template v-for="t in document.available_transitions">
							<v-btn
								:key="t"
								small
								class="ml-2 mb-1"
								:color="statusMeta(t).color"
								dark
								@click="transition(t)">
								<v-icon left small>{{ statusMeta(t).icon }}</v-icon>
								{{ statusMeta(t).text }}
							</v-btn>
						</template>
					</div>
					<p v-if="document.approved_at" class="mt-3 mb-0 grey--text">
						Approvato il {{ document.approved_at }}
					</p>
				</v-card-text>
			</v-card>

			<!-- Norme e requisiti (matrice di conformità) -->
			<v-card v-if="document" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme e requisiti</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openTagsDialog">
						<v-icon left small>mdi-pencil</v-icon> Modifica
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<div class="mb-3">
						<span class="grey--text mr-2">Norme:</span>
						<template v-if="document.norms && document.norms.length">
							<v-chip v-for="n in document.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>
								{{ n.text }}
							</v-chip>
						</template>
						<span v-else class="grey--text">— nessuna —</span>
					</div>
					<div>
						<span class="grey--text mr-2">Requisiti collegati:</span>
						<template v-if="document.requirements && document.requirements.length">
							<v-chip v-for="r in document.requirements" :key="r.value" outlined small class="mr-1 mb-1">
								{{ r.clause }} — {{ r.title }}
							</v-chip>
						</template>
						<span v-else class="grey--text">— nessuno —</span>
					</div>
				</v-card-text>
			</v-card>

			<!-- File e versioni del documento -->
			<dms-uploader class="mt-4"
				:id="id"
				attachable-type="compliancedocument"
			></dms-uploader>

			<!-- Modifica documento -->
			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn
							v-on="{ ...tooltip }"
							@click.native="$eventBusUtility.goTo($router, 'compliancedocuments-edit', id)"
							color="primary"
							dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<!-- Dialog tag norme/requisiti -->
			<v-dialog v-model="tagsDialog" max-width="640" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3">
						<p class="pl-2 pl-xl-3 mb-0">Norme e requisiti</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete
							v-model="form.norms"
							:items="normOptions"
							item-text="text"
							item-value="value"
							label="Norme applicabili"
							outlined dense
							:menu-props="{'offset-y': true}"
							multiple chips small-chips deletable-chips
							prepend-icon="mdi-certificate"
						></v-autocomplete>
						<v-autocomplete
							v-model="form.requirements"
							:items="requirementOptions"
							item-text="label"
							item-value="value"
							label="Requisiti / controlli soddisfatti"
							outlined dense
							:menu-props="{'offset-y': true}"
							multiple chips small-chips deletable-chips
							prepend-icon="mdi-format-list-checks"
							:search-input.sync="reqSearch"
						></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="tagsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="saving" @click="saveTags">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceDocument',

	props: {
		id: Number
	},

	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			tagsDialog: false,
			saving: false,
			form: { norms: [], requirements: [] },
			normOptions: [],
			requirementOptions: [],
			reqSearch: null,
			statusMap: {
				bozza: { text: 'Bozza', color: '#9e9e9e', icon: 'mdi-file-edit-outline' },
				in_verifica: { text: 'In verifica', color: '#ff9800', icon: 'mdi-file-search-outline' },
				approvato: { text: 'Approvato', color: '#03a9f4', icon: 'mdi-file-check-outline' },
				pubblicato: { text: 'Pubblicato', color: '#4caf50', icon: 'mdi-file-document-check' },
				obsoleto: { text: 'Obsoleto', color: '#f44336', icon: 'mdi-file-remove-outline' }
			}
		}
	},

	computed: {
		document() {
			return this.models.compliancedocument
		}
	},

	created() {
		this.load()
	},

	methods: {
		load() {
			this.loading = true
			this.axios.get('compliancedocuments/' + this.id).then(response => {
				this.models = response.data.models
				this.infos = response.data.infos
				this.loading = false
			}, () => {
				this.loading = false
				this.$store.commit('setSnackbarError')
			})
		},

		statusMeta(status) {
			return this.statusMap[status] || { text: status, color: 'grey', icon: 'mdi-help-circle' }
		},

		transition(target) {
			this.axios.post('compliancedocuments/' + this.id + '/transition', { status: target }).then(() => {
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Stato aggiornato', timeout: 4000 })
				this.load()
			}, error => {
				const msg = error.response && error.response.data ? error.response.data.message : 'Errore nel cambio di stato'
				this.$store.commit('setSnackbar', { value: true, color: 'error', text: msg, timeout: 6000 })
			})
		},

		openTagsDialog() {
			this.form.norms = (this.document.norms || []).map(n => n.value)
			this.form.requirements = (this.document.requirements || []).map(r => r.value)
			// precarica le option con i requisiti già collegati così restano visibili
			this.requirementOptions = (this.document.requirements || []).map(r => ({ value: r.value, label: r.clause + ' — ' + r.title }))
			this.loadNormOptions()
			this.tagsDialog = true
		},

		loadNormOptions() {
			this.axios.get('compliance-norms-options').then(response => {
				this.normOptions = response.data.data
			})
		},

		loadRequirementOptions() {
			this.axios.get('compliance-requirements-options').then(response => {
				this.requirementOptions = response.data.data.map(r => ({ value: r.value, label: r.text }))
			})
		},

		saveTags() {
			this.saving = true
			this.axios.put('compliancedocuments/' + this.id, {
				norms: this.form.norms,
				requirements: this.form.requirements
			}).then(() => {
				this.saving = false
				this.tagsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => {
				this.saving = false
				this.$store.commit('setSnackbarError')
			})
		}
	},

	watch: {
		tagsDialog(open) {
			if (open && !this.requirementOptions.length) this.loadRequirementOptions()
		}
	}
}
</script>
